export * from './medispan-result.component';
